var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1025 10.3658L12.1367 12.3692C11.485 12.775 10.7692 13.1625 10 13.5142V18.75C10 19.4408 9.44083 20 8.75 20C8.05917 20 7.5 19.4408 7.5 18.75V14.4542C4.63333 15.3 2.26583 15.17 1.7625 13.9842C1.25667 12.7908 2.795 10.8917 5.37583 9.28749C3.14083 6.81249 1.405 3.88416 0.864999 1.52916C0.710833 0.856655 1.13083 0.185822 1.80417 0.0316552C2.475 -0.122511 3.14833 0.297489 3.30167 0.969989C3.545 2.03166 4.21667 3.48166 5.21083 4.99916H9.02833C9.99667 3.47582 10.6208 2.03249 10.865 0.969989C11.0475 0.173322 11.9558 -0.266678 12.7258 0.174155C13.2058 0.449155 13.4208 1.01416 13.2958 1.55332C12.8792 3.34416 11.8225 5.43999 10.4067 7.40416C10.22 7.66249 10.2183 8.01249 10.4067 8.26916C10.41 8.27332 10.4133 8.27832 10.4167 8.28249C10.705 8.67332 11.2867 8.68166 11.5825 8.29666C11.9275 7.84666 12.3042 7.27332 12.5 6.70416C14.1633 6.54832 15.3917 6.86332 15.7375 7.67749C15.8708 7.99249 15.855 8.35832 15.7225 8.75416L18.3975 7.96666C19.0583 7.77166 19.7542 8.15082 19.9492 8.81332C20.1442 9.47499 19.765 10.17 19.1025 10.365V10.3658ZM7.08333 4.16666C8.23417 4.16666 9.16667 3.23416 9.16667 2.08332C9.16667 0.932489 8.23417 -1.14153e-05 7.08333 -1.14153e-05C5.9325 -1.14153e-05 5 0.932489 5 2.08332C5 3.23416 5.9325 4.16666 7.08333 4.16666Z",
    fill: "url(#paint0_linear_192_481)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_481",
    x1: 10.4167,
    y1: -0.000610352,
    x2: 10.4167,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance);
export default __webpack_public_path__ + "static/media/dance.08749dffedee75c6e6fee0e8e72b5f69.svg";
export { ForwardRef as ReactComponent };